module.exports = __webpack_public_path__ + "img/sy-pic5.37614dfa.png";